import { AfterViewInit, Component, input } from '@angular/core';

import { FleetOrder } from '../../interfaces/fleet-order';

@Component({
    selector: 'fleet-order',
    templateUrl: './fleet-order.component.html',
    standalone: false
})
export class FleetOrderComponent {
  fleetOrder = input<FleetOrder>();
};
